import { isEmbeddedPage } from 'config/eva';

/**
 * Open the Osano preference center. No-op on PWN Health or embedded contexts.
 *
 * Uses `Osano('onInitialized', cb)` rather than racing a timeout: Osano queues
 * the callback if the CMP is still loading and fires it immediately once it's
 * already initialized, so this works regardless of CMP load timing.
 */
export function openCookiePreferences() {
  if (typeof window === 'undefined') {
    return;
  }
  if (window.isPwnHealthPage || isEmbeddedPage()) {
    return;
  }

  const Osano = window.Osano;
  if (!Osano) {
    return;
  }

  Osano('onInitialized', () => {
    window.Osano?.cm?.showDrawer?.();
  });
}
